module.exports = __webpack_public_path__ + "media/images/flags/um-e834167e589569457e802802d3958724.svg";